import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	deploymentsLink: {
		id: 'development-summary-deployments-view-link.deployments-link',
		defaultMessage: 'See all deployments',
		description: 'a link to the deployments view',
	},
});
